import { useQuery } from '@tanstack/react-query';
import { expertPostsService } from '@/services/expert-posts.service';
import { ExpertPostOptions } from '@/types/expert-posts';

export const EXPERT_POST_OPTIONS_QUERY_KEY = ['expert-posts', 'options'] as const;

export const useExpertPostOptions = () => {
  const { data, isLoading, error, refetch } = useQuery<ExpertPostOptions>({
    queryKey: EXPERT_POST_OPTIONS_QUERY_KEY,
    queryFn: expertPostsService.getOptions,
    staleTime: 5 * 60 * 1000,
  });

  return {
    visibilities: data?.visibilities ?? [],
    publicationStatuses: data?.publicationStatuses ?? [],
    isLoading,
    error,
    refetch,
  };
};
